import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-attendance-leaves',
  templateUrl: './attendance-leaves.component.html',
  styleUrls: ['./attendance-leaves.component.css']
})
export class AttendanceLeavesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Attendance-Leaves/attendance-leaves.component.ts